import { render, staticRenderFns } from "./setMealConfig.vue?vue&type=template&id=38b18279&scoped=true"
import script from "./setMealConfig.vue?vue&type=script&lang=js"
export * from "./setMealConfig.vue?vue&type=script&lang=js"
import style0 from "./setMealConfig.vue?vue&type=style&index=0&id=38b18279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b18279",
  null
  
)

export default component.exports